// Small site-owned Less helpers for styles that predate Bootstrap 5.
.square(@size) {
  width: @size;
  height: @size;
}

.img-retina(@file-1x, @file-2x, @width-1x, @height-1x) {
  background-image: url(@file-1x);
  background-size: @width-1x @height-1x;
  @media only screen and (min-resolution: 2dppx) {
    background-image: url(@file-2x);
  }
}

.button-size(@padding-vertical, @padding-horizontal, @font-size, @line-height, @border-radius) {
  padding: @padding-vertical @padding-horizontal;
  font-size: @font-size;
  line-height: @line-height;
  border-radius: @border-radius;
}

.button-variant(@color, @background, @border) {
  --bs-btn-color: @color;
  --bs-btn-bg: @background;
  --bs-btn-border-color: @border;
  --bs-btn-hover-color: @color;
  --bs-btn-hover-bg: darken(@background, 5%);
  --bs-btn-hover-border-color: darken(@border, 5%);
  --bs-btn-active-color: @color;
  --bs-btn-active-bg: darken(@background, 8%);
  --bs-btn-active-border-color: darken(@border, 8%);
  color: @color;
  background-color: @background;
  border-color: @border;
  &:hover,
  &:focus {
    color: @color;
    background-color: darken(@background, 5%);
    border-color: darken(@border, 5%);
  }
}

.text-overflow() {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-muted() {
  color: @text-muted;
}

.center-block() {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.img-responsive() {
  display: block;
  max-width: 100%;
  height: auto;
}

.transition-transform(@transition) {
  transition: transform @transition;
}

.border-top-radius(@radius) {
  border-top-left-radius: @radius;
  border-top-right-radius: @radius;
}

.border-bottom-radius(@radius) {
  border-bottom-left-radius: @radius;
  border-bottom-right-radius: @radius;
}

.border-right-radius(@radius) {
  border-top-right-radius: @radius;
  border-bottom-right-radius: @radius;
}
